const dateUtils = {
    // 当前日期添加天数
    addDays: function(days = 0){
        return new Date(this.getFullYear(), this.getMonth(), this.getDate() + days);
    },
    // 当前日期添加月数
    addMonths: function(months = 0) {
        return new Date(this.getFullYear() + years, this.getMonth() + months, this.getDate())
    },
    // 当前日期添加年数
    addYears : function(years = 0) {
        return new Date(this.getFullYear() + years, this.getMonth, this.getDate());
    },
    getYesterday : function() {
        return this.addDays(-1);
    },
    // 当前日期与另一日期相差多少天
    diffDate : function(date = new Date()) { 
        return parseInt((this - date)/ (1000 * 60 * 60 * 24));
    },
    // 获取当前周的开始日期
    getWeekStartDate : function() { 
        return new Date(this.getFullYear(), this.getMonth(), this.getDate() - new Date().getDay() + 1);
    },
    // 获取当前周的结束日期
    getWeekEndDate : function()  { 
        return new Date(this.getFullYear(), this.getMonth(),   this.getDate() + (7 - new Date().getDay()));
    },
    // 获取上周的开始日期
    getLastWeekStartDate : function() { 
        return new Date(this.getFullYear(), this.getMonth(),  this.getDate() - new Date().getDay() - 6);
    },
    // 获取上周的结束日期
    getLastWeekEndDate : function() { 
        return new Date(this.getFullYear(), this.getMonth(), this.getDate() - new Date().getDay());
    },
    // 获取本月的开始日期
    getMonthStartDate : function() { 
        return  new Date(this.getFullYear(), this.getMonth(), 1);
    },
    // 获取本月的结束日期
    getMonthEndDate : function() { 
        return  new Date(this.getFullYear(), this.getMonth()+1, 0);
    },
    // 获取上月的开始日期
    getLastMonthStartDate : function() { 
        return  new Date(this.getFullYear() - (this.getMonth()-1 == -1 ? -1 :  0), this.getMonth()-1 , 1);
    },
    // 获取上月的结束日期
    getLastMonthEndDate : function() {
        return  new Date(this.getFullYear() - (this.getMonth()-1 == -1 ? -1 :  0), this.getMonth() , 0);
    },
    // 获取下月的结束日期
    getNextMonthEndDate : function() {
        return new Date(this.getFullYear() + (this.getMonth() + 2 >= 12 ? 1 :  0),  this.getMonth() + 1 >= 12 ? 1 : this.getMonth() + 2 , 0);
    },
}

Object.assign(Date.prototype, dateUtils);


// WEBPACK FOOTER //
// ./src/common/dateUtil.js